import $ from 'jquery'
import BasicLightBox from '../BasicLightbox'
import LightBoxWrapper from './LightBoxWrapper'

class LightBox extends BasicLightBox {
    constructor($el = $('body'), {
        close_tab_confirmation_message_key = '',
        exist_invalid_fields_message_key = '',
        cancel_confirmation_message_key = '',
    } = {}) {
        super()
        this.params = {
            $el
        }

        this.close_tab_confirmation_message_key = close_tab_confirmation_message_key
        this.exist_invalid_fields_message_key = exist_invalid_fields_message_key
        this.cancel_confirmation_message_key = cancel_confirmation_message_key
    }

    init({
             id,
             header = null,
             content = null,
             footer = null,
             classNames = '',
             correctionOffset = 0,
             moireDivId,
             cancelCallback = () => this.hide()
         }) {

        this.components = {
            header,
            footer,
            content
        }

        // temporary we need this
        $(`#${id}`).remove()

        this.wrapper = new LightBoxWrapper(
            this.params.$el,
            {
                id,
                header: header,
                content: content,
                footer: footer,
                classNames: classNames,
                correctionOffset: correctionOffset
            }
        ).init()


        super.init(null, null, moireDivId)

        this.setCancelCallback(cancelCallback)

        return this
    }

    getWrapper() {
        return this.wrapper
    }

    getContent() {
        return this.components.content
    }

    getHeader() {
        return this.components.header
    }

    getFooter() {
        return this.components.footer
    }

    /**
     * Temporary solution for compatibility with BasicLightbox
     */
    getPopupEl() {
        return this.wrapper.getEl()
    }

    /**
     * Temporary solution for compatibility with BasicLightbox
     */
    getFooterEl() {
        return this.components.footer.getEl()[0]
    }

    /**
     * Temporary solution for compatibility with BasicLightbox
     */
    getCommitButtonEl() {
        return this.components.footer.getCommitBtnEl()[0]
    }

    /**
     * Temporary solution for compatibility with BasicLightbox
     */
    getCancelButtonEl() {
        return this.components.footer.getCancelBtnEl()[0]
    }

    /**
     * Temporary solution for compatibility with BasicLightbox
     */
    getCloseButtonEl() {
        return this.components.header.getCloseButtonEl()[0]
    }

    getScrollPosition() {
        return this.wrapper.scrollableContainer.innerScroll.y
    }

    refreshScroll() {
        this.wrapper.update()
    }

    updateErrors(showErrorInFooter) {
        if (this.hasErrors()) {
            if (showErrorInFooter)
                this.displayErrorInFooter();
        }
        else
            this.removeErrorInFooter();
    }
}

export default LightBox



// WEBPACK FOOTER //
// ./web/js/components/LightBox.js